import linhaDivisoria from '../assets/linha-divisoria.png'
import facebookLogo from '../assets/facebook.png'
import instagramLogo from '../assets/instagram.png'
import twitterLogo from '../assets/twitter.png'
import linkedinLogo from '../assets/linkedin.png'

import getLogo from './Logos';

const Firma = (props) => {
  console.log("Firma");
  console.log(props);

  const {
    nome,
    sobreNome,
    cargo,
    localidad,
    codigo,
    celular,
    empresa: {
      nombre,
      logo,
      width,
      height,
      link,
      social: {
        instagram,
        facebook,
        twitter,
        linkedin
      }
    }
  } = props;

  return (
    <table cellPadding={0} cellSpacing={0}
      style={{
        maxWidth: "100%",
        whiteSpace: "nowrap",
        background: "#FFFFFF",
      }}
    >
      <tbody cellPadding={0} cellSpacing={0}>
        <tr>
          <td style={{width: width}}>
            <a href={link}>
              <img
                src={getLogo(logo)}
                width={width}
                height={height}
                alt={""}
              />
            </a>
          </td>

          <td height={"100%"} width={40}>&nbsp;</td>
          <td height={"100%"} width={24}>
            <img src={linhaDivisoria} width={24} height={165} alt={""} />
          </td>
          <td height={"100%"} width={40}>&nbsp;</td>

          <td style={{
            fontFamily: "Montserrat, Arial, sans-serif",
            fontWeight: "bold",
            fontSize: "12px",
            lineHeight: 1.5,
            whiteSpace: "nowrap",
          }}>
            <div style={{ fontSize: "28px" }}>
              <span style={{
                color: "#0A2B69", fontWeight: "normal",
              }}>{nome}</span> <span style={{
                color: "#0A2B69",                
              }}>{sobreNome}</span>
            </div>
            <div style={{
              fontWeight: "normal", textAlign: 'left'
            }}>
              <div style={{
                color: "#0A2B69",
              }}>{cargo}</div>
              <div style={{ color: "#0A2B69", fontWeight: "bold"}}>
                <div>{localidad}</div>
                <div>
                  <span>{codigo}</span> <span>{celular}</span>
                </div>
              </div>
              <div style={{
                fontWeight: "bold",
              }}>
                <a style={{
                  color: "#0A2B69",
                  textDecorationWidth: 0,
                  textDecorationColor: "transparent",
                  textDecorationLine: "unset",
                }} href={link}>
                  {(nombre === "TOPAZ" || nombre === "TOPAZ CRK") &&
                    <span>topaz<span style={{color: "#0A2B69"}}>evolution</span>.com</span>
                  }
                  {nombre === "COBIS TOPAZ" &&
                    <span>cobistopaz.com</span>
                  }
                </a>
              </div>
            </div>
            {/* Redes Sociais */}
            <table cellPadding={0} cellSpacing={0} style={{
              marginTop: "5px",
            }}>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "middle" }}>
                    <a href={linkedin}>
                      <img src={linkedinLogo} width={27} height={27} alt={"Linkedin"} />
                    </a>
                  </td>
                  {(nombre === "TOPAZ" || nombre === "TOPAZ CRK") &&
                    <td width={20}>
                      <a href={instagram}>
                        <img src={instagramLogo} width={27} height={27} alt={"Instagram @topazevolution"}/>
                      </a>
                    </td>
                  }
                  {nombre === "COBIS TOPAZ" &&
                    <>
                    <td width={20} style={{ verticalAlign: "middle" }}>
                      <a href={facebook}>
                        <img src={facebookLogo} width={27} height={27} alt={"Facebook @cobistopaz"}/>
                      </a>
                    </td>
                    <td width={20} style={{ verticalAlign: "middle" }}>
                      <a href={twitter}>
                        <img src={twitterLogo} width={27} height={27} alt={"Twitter @cobistopaz"}/>
                      </a>
                    </td>
                    </>
                  }
                  <td>&nbsp;</td>
                  <td style={{
                    fontFamily: "Montserrat, Arial, sans-serif",
                    fontWeight: "bold",
                    whiteSpace: "nowrap",
                    color: "#0A2B69",
                    verticalAlign: "middle",
                  }}>
                  {(nombre === "TOPAZ" || nombre === "TOPAZ CRK") &&
                    <span>/topazevolution</span>
                  }
                  {nombre === "COBIS TOPAZ" &&
                    <span>/cobistopaz</span>
                  }
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default Firma;
